module.exports = __webpack_public_path__ + "static/media/database.2339de65.png";